import { useContext } from "react";

import { AnalyticsService } from "@app/util/analytic/AnalyticsService";

import AnalyticsContext from "./AnalyticsContext";

const useAnalytics = (): AnalyticsService => useContext<AnalyticsService>(AnalyticsContext);

export default useAnalytics;
